export default __webpack_public_path__ + "a6f1182f8678dfcf8fa7b7895a9c4fff.svg";